import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TrailingSlashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the current path has a trailing slash (except for root "/")
    if (location.pathname !== "/" && location.pathname.endsWith("/")) {
      // Remove the trailing slash and navigate to the new path
      const pathWithoutTrailingSlash = location.pathname.slice(0, -1);
      navigate(pathWithoutTrailingSlash + location.search + location.hash, {
        replace: true,
      });
    }
  }, [location, navigate]);

  return null;
};

export default TrailingSlashRedirect;
